var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"notification"},[_c('b-link',{on:{"click":_vm.handleOpenSideBar}},[_vm._v("\n      "+_vm._s(_vm.feedBackTitle)+"\n    ")]),_c('form-side-bar',{attrs:{"sb-model":_vm.ionaModel,"sb-id":_vm.sbId,"profile":_vm.profile,"my-app":_vm.myApp,"comm-with":"iona"},on:{"close-clicked":_vm.handleSidebarClose}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }